export default function (discount) {
  if (discount != 0 && !discount) return null;
  if (String(discount).endsWith("%")) return discount;
  else return `${discount}%`;
}
